module.exports = __webpack_public_path__ + "img/kanban.c8ee2b79.png";